export const KM_PREFERENCES_FORM_TEST_IDS = {
    REGION_INPUT: "region-input",
    LOCATION_PILL: "home-match-user-preferences-location-pill",
    FINANCING_SERVICES_SWITCHER: "financing-services-switcher",
    ROOMS_SELECTOR: "rooms-selector",
    BUDGET: "km-preferences-budget",
    EDIT_PAGE: "km-preferences-edit-page",
    MODAL: "km-preferences-survey-modal",
    CLOSE: "km-preferences-close",
    SECTION: "km-preferences-section",
    SAVE: "km-preferences-save",
    DISCARD: "km-preferences-discard",
    LOCATION_CANCEL: "km-preferences-location-cancel",
    LOCATION_APPLY: "km-preferences-location-apply"
};
export const KM_PREFERENCES_FORM_TEST_IDS = {
    REGION_INPUT: "region-input",
    LOCATION_PILL: "home-match-user-preferences-location-pill",
    FINANCING_SERVICES_SWITCHER: "financing-services-switcher",
    ROOMS_SELECTOR: "rooms-selector",
    BUDGET: "km-preferences-budget",
    EDIT_PAGE: "km-preferences-edit-page",
    MODAL: "km-preferences-survey-modal",
    CLOSE: "km-preferences-close",
    SECTION: "km-preferences-section",
    SAVE: "km-preferences-save",
    DISCARD: "km-preferences-discard",
    LOCATION_CANCEL: "km-preferences-location-cancel",
    LOCATION_APPLY: "km-preferences-location-apply"
};
